import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import RememberingLeonardPage from "./pages/RememberingLeonardPage";
import DonatePage from "./pages/DonatePage";
import FilmPage from "./pages/FilmPage";
import LLAPTributePage from "./pages/LLAPTributePage";
import AnniversaryPage from "./pages/AnniversaryPage";
import AboutPage from "./pages/AboutPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import HonoreesPage from "./pages/HonoreesPage";
import HonoreeDetailPage from "./pages/HonoreeDetailPage";
import NominationsPage from "./pages/NominationsPage";
import InTheNewsPage from "./pages/InTheNewsPage";
import DownloadsPage from "./pages/DownloadsPage";
import PartnersPage from "./pages/PartnersPage";
import InitiativesPage from "./pages/InitiativesPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/remembering-leonard" element={<RememberingLeonardPage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/film" element={<FilmPage />} />
          <Route path="/llap-tribute" element={<LLAPTributePage />} />
          <Route path="/anniversary" element={<AnniversaryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/honorees" element={<HonoreesPage />} />
          <Route path="/honorees/:id" element={<HonoreeDetailPage />} />
          <Route path="/nominations" element={<NominationsPage />} />
          <Route path="/news" element={<InTheNewsPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/initiatives" element={<InitiativesPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
